/**
 * Formats a date to a readable string based on the user's local time.
 * @param dateStr ISO 8601 date string
 * @returns Formatted date string (e.g., "December 21, 2024, 7:45 PM")
 */
export function formatDate(dateStr: string): string {
  const date = new Date(dateStr);
  return date.toLocaleString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  });
}

/**
 * Checks if the current date is after the given date.
 * @param dateStr ISO 8601 date string
 * @returns Boolean indicating if the current date is after the given date
 */
export function isAfterNow(dateStr: string): boolean {
  return new Date() > new Date(dateStr);
}

/**
 * Adds hours to a given date string and returns a new date string.
 * @param dateStr ISO 8601 date string
 * @param hours Number of hours to add
 * @returns New date string with hours added
 */
export function addHours(dateStr: string, hours: number): string {
  const date = new Date(dateStr);
  date.setHours(date.getHours() + hours);
  return date.toISOString();
}
